import React from 'react';
import { Grid } from '@material-ui/core';
import { Input } from 'components/shared/input';
import ReactPlayer from 'react-player';
import { InstagramEmbed, FacebookEmbed, TikTokEmbed, TwitterEmbed, PinterestEmbed } from 'react-social-media-embed';
import { isInstagram, isFacebookReel, isFacebookVideo, isFacebookShareUrl, getFacebookVideoEmbedUrl, isTikTok, isTwitter, isLinkedIn, isPinterest, getLinkedInEmbedUrl } from 'utils';

interface AddEmbedVideoProps {
 embededVideoUrl: string;
 setEmbededVideoUrl(e: string): void;
}

export const AddEmbedVideo = ({ embededVideoUrl, setEmbededVideoUrl }: AddEmbedVideoProps) => {
 const isInstagramUrl = embededVideoUrl && isInstagram(embededVideoUrl);
 const isFacebookReelUrl = embededVideoUrl && isFacebookReel(embededVideoUrl);
 const isFacebookVideoUrl = embededVideoUrl && isFacebookVideo(embededVideoUrl);
 const isFacebookShareUrlDetected = embededVideoUrl && isFacebookShareUrl(embededVideoUrl);
 const isFacebookUrl = isFacebookReelUrl || isFacebookVideoUrl;
 const isTikTokUrl = embededVideoUrl && isTikTok(embededVideoUrl);
 const isTwitterUrl = embededVideoUrl && isTwitter(embededVideoUrl);
 const isLinkedInUrl = embededVideoUrl && isLinkedIn(embededVideoUrl);
 const isPinterestUrl = embededVideoUrl && isPinterest(embededVideoUrl);

 return (
  <Grid container spacing={2}>
   <Grid item xs={12}>
    {embededVideoUrl && (
     <>
      {isInstagramUrl ? (
       <div className="social-embed-preview">
        <InstagramEmbed url={embededVideoUrl} width={328} />
       </div>
      ) : isTikTokUrl ? (
       <div className="social-embed-preview">
        <TikTokEmbed url={embededVideoUrl} width={325} />
       </div>
      ) : isTwitterUrl ? (
       <div className="social-embed-preview social-embed-preview--twitter">
        <TwitterEmbed url={embededVideoUrl} width={325} />
       </div>
      ) : isLinkedInUrl ? (
       <div className="social-embed-preview social-embed-preview--linkedin">
        <iframe
         title="LinkedIn embed"
         src={getLinkedInEmbedUrl(embededVideoUrl)}
         width="100%"
         height="700"
         frameBorder="0"
         allowFullScreen
        />
       </div>
      ) : isPinterestUrl ? (
       <div className="social-embed-preview">
        <PinterestEmbed url={embededVideoUrl} width={325} />
       </div>
      ) : isFacebookShareUrlDetected ? (
       <div className="social-embed-preview">
        <iframe
         title="Facebook share video"
         src={getFacebookVideoEmbedUrl(embededVideoUrl)}
         width="100%"
         height="500"
         style={{ border: "none", overflow: "hidden" }}
         scrolling="no"
         frameBorder="0"
         allowFullScreen
         allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
        />
       </div>
      ) : isFacebookUrl ? (
       <div className="social-embed-preview">
        <FacebookEmbed url={embededVideoUrl} width={280} />
       </div>
      ) : (
       <div className="social-embed-wrapper social-embed-wrapper--aspect">
        <ReactPlayer url={embededVideoUrl} controls width="100%" height="100%" />
       </div>
      )}
     </>
    )}
   </Grid>
   <Grid item xs={12}>
    <Input label='Video URL' onChange={(e: any) => setEmbededVideoUrl(e.target.value)} value={embededVideoUrl} fullWidth />
   </Grid>
  </Grid>
 );
};
